import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
});

api.interceptors.request.use(
  (config) => config,
  (error) => {
    console.error('[AXIOS] REQUEST ERROR:', error);
    return Promise.reject(error);
  },
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('[AXIOS] RESPONSE ERROR:', error.response?.status, error.config?.url, error.message);
    return Promise.reject(error);
  },
);

export default api;
